/** @format */

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';

export const CHART_HEIGHT = 120;
export const MAX_FORECAST_POINTS = 2;
export const MIN_CHART_DAYS = 7;
export const TARGET_WIDGETS: ChartIds[] = ['clicks', 'shows', 'cpc', 'ctr'];
